import React from 'react';
import { useAuth } from './deps.js';

const AdminHeader = ({ title, titleAccessory, showViewerSubtitle, actions }) => {
  const { user } = useAuth();

  return (
    <div className="admin-header">
      <div className="admin-header-title">
        <div className="admin-header-title-text">
          <div className="admin-header-title-with-help">
            <h1 className="tab-page-title">{title}</h1>
            {titleAccessory}
            {showViewerSubtitle && user?.name && (
              <span className="admin-header-subtitle">
                Viewing {user.name}'s admin panel
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="admin-header-actions admin-actions-row">
        {actions}
      </div>
    </div>
  );
};

export default AdminHeader;
